import type { BadgeProps } from '@shared/ui';
import type { ProductStatus } from '../model/types';

const STATUS_TONE: Record<ProductStatus, NonNullable<BadgeProps['tone']>> = {
  DRAFT: 'neutral',
  PENDING_MODERATION: 'warning',
  PUBLISHED: 'success',
  REJECTED: 'danger',
  ARCHIVED: 'neutral',
};

const STATUS_LABEL: Record<ProductStatus, string> = {
  DRAFT: 'Draft',
  PENDING_MODERATION: 'On moderation',
  PUBLISHED: 'Published',
  REJECTED: 'Rejected',
  ARCHIVED: 'Archived',
};

export function productStatusTone(status: ProductStatus) {
  return STATUS_TONE[status];
}

export function productStatusLabel(status: ProductStatus): string {
  return STATUS_LABEL[status];
}

export function canEditProduct(status: ProductStatus): boolean {
  return status !== 'ARCHIVED' && status !== 'PENDING_MODERATION';
}

export function canSubmitProduct(status: ProductStatus): boolean {
  return status === 'DRAFT' || status === 'REJECTED';
}

export function canArchiveProduct(status: ProductStatus): boolean {
  return status !== 'ARCHIVED';
}
